import React from "react";

import { useHistory } from "react-router-dom";

import Icon from "shared/components/Icon";
import InfoPage from "shared/templates/InfoPage";
import { goBackWithReload } from "shared/utils/routing";

const ErrorPage = () => {
  const history = useHistory();

  return (
    <InfoPage
      title="Error"
      description="Sorry, something went wrong on our end. Please refresh the page or try again later."
      MainIcon={Icon.ErrorIcon}
      button={{
        children: "Back",
        PrefixIcon: Icon.ButtonBackArrowIcon,
        onClick: () => goBackWithReload(history),
      }}
      width="900px"
    />
  );
};

export default ErrorPage;
